import Game from "../../../../../src/Game";
import Circle from "../../../../../src/entities/Circle";
import InfoSlider from "../../../../../src/entities/InfoSlider/InfoSlider";
import GuideText from "../../../../../src/entities/GuideText";

import PointManager from "./PointManager/PointManager";
import PointTagManager from "./PointTagManager";
import LineManager from "./LineManager";
import AngleManager from "./AngleManager/AngleManager";
import SupplAngleManager from "./AngleManager/SupplAngleManager";
import CircleAnimationManager from "./CircleAnimationManager/CircleAnimationManager";
import CalculationLineManager from "./CalculationLineManager";
import SliderManager from "./SliderManager";
import SupplementaryAnimation from "./SupplementaryAnimation/SupplementaryAnimation";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import SupplModeSwitcherCon from "../entities/SupplModeSwitcherCon";
import GenRanQuadriButton from "../entities/GenRanQuadriButton";
import { CIRCLE_RADIUS, CENTER_OF_CIRCLE, INFO_SLIDER_COORD } from "../types/Config";


export default class ComponentManager {
  static instance: ComponentManager;
  Game = Game.getInstance();

  cRadius = CIRCLE_RADIUS;
  cCoord = CENTER_OF_CIRCLE;
  circle: Circle;
  PointManager: PointManager;
  PointTagManager: PointTagManager;
  LineManager: LineManager;
  AngleManager: AngleManager;
  SupplAngleManager: SupplAngleManager;
  CircleAnimationManager: CircleAnimationManager;
  CalcLineManager: CalculationLineManager;
  SliderManager: SliderManager;
  infoSlider = new InfoSlider(INFO_SLIDER_COORD);

  constructor() {
    if (!ComponentManager.instance) {
      ComponentManager.instance = this;
    }
    const isVertical = this.isVertical();

    this.PointManager = new PointManager();
    const radians = this.PointManager.getRadians();
    this.circle = new Circle(this.cCoord, radians, Array(4).fill(0x000000));

    this.PointTagManager = new PointTagManager(this.cCoord);
    this.LineManager = new LineManager();
    this.AngleManager = new AngleManager();
    this.SupplAngleManager = new SupplAngleManager();
    this.CalcLineManager = new CalculationLineManager(isVertical);
    this.SliderManager = new SliderManager();
    this.CircleAnimationManager = new CircleAnimationManager(
      this.PointManager,
      this.AngleManager,
      this.SupplAngleManager,
      this.LineManager,
      this.CalcLineManager,
      this.circle,
      this.cCoord
    );

    new GuideText();
    new SupplementaryAnimation(this.PointManager, this.AngleManager, this.LineManager);
    new SupplModeSwitcherCon();
    new GenRanQuadriButton();

    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.drawElements());
    rootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());
    this.drawElements();
  }
  static getInstance = () => ComponentManager.instance;
  isVertical() {
    const dim = this.Game.getDim();
    if (dim.WIDTH > dim.HEIGHT) {
      return false
    }
    this.cCoord.x = dim.WIDTH / 2;
    this.cCoord.y = dim.HEIGHT / 2 - 100;
    return true
  }
  drawElements() {
    const radians = this.PointManager.getRadians();
    const radius = this.PointManager.circleRadius;
    const redPointsCoord = this.PointManager.getRedPointsCoord();

    this.PointManager.draw();
    this.circle.draw({ radians: [radians[1], radians[0]], radius });
    this.LineManager.draw(redPointsCoord);
    this.AngleManager.draw(redPointsCoord, false);
    this.SupplAngleManager.draw(redPointsCoord, false);
    this.PointTagManager.updateCoord(radians, radius + 30);
  }
}
